import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import Caption from 'LuxKit/Typography/Caption'
import FormatCurrency from 'components/Common/FormatCurrency'

const CaptionBlock = styled(Caption)`
  display: flex;
  flex-direction: row;
  gap: ${rem(4)};
  align-items: center;
`

interface Props {
  price: number
  joiningFee: number
  waiveFee: boolean
  tileVariant?: 'default' | 'condensed'
}

function LuxPlusCartReviewPriceStack({ price, joiningFee, waiveFee, tileVariant = 'default' }: Props) {
  if (price === 0) {
    return null
  }

  return (
    <Group
      direction="vertical"
      horizontalAlign="start"
      tabletHorizontalAlign={tileVariant === 'condensed' ? 'start' : 'end'}
    >
      <PriceRowPrice
        size="S"
        price={waiveFee ? price : price + joiningFee}
        priceFormat="preciseDollar"
        saleUnit=""
      />
      {waiveFee && (
        <CaptionBlock
          variant="medium"
          colour="lux-plus"
          weight="bold"
          wrap="no-wrap"
        >
          <span>Special offer: No joining fee</span>
          <s><FormatCurrency value={joiningFee} format="preciseDollar" /></s>
        </CaptionBlock>
      )}
    </Group>
  )
}

export default LuxPlusCartReviewPriceStack
